




























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ISortParameters, ITransaction, IAccount } from "@/interfaces";
import TransactionService from "@/services/transaction";
import { CoreTransaction } from "@/enums";

@Component
export default class WalletTransactions extends Vue {
  @Prop({ required: true }) public wallet: IAccount;

  private transactions: ITransaction[] | null = null;
  private receivedCount = 0;
  private sentCount = 0;
  private locksCount = 0;
  private meta: any | null = null;

  get isTypeSent() {
    return this.type === "sent";
  }

  get isTypeReceived() {
    return this.type === "received";
  }

  get isTypeLocks() {
    return this.type === "locks";
  }

  get type() {
    return this.$store.getters["ui/walletTransactionTab"];
  }

  set type(type: string) {
    this.$store.dispatch("ui/setWalletTransactionTab", type);
  }

  get hasHtlcEnabled() {
    return this.$store.getters["network/hasHtlcEnabled"];
  }

  get sortParams() {
    return this.$store.getters["ui/transactionSortParams"];
  }

  set sortParams(params: ISortParameters) {
    this.$store.dispatch("ui/setTransactionSortParams", {
      field: params.field,
      type: params.type,
    });
  }

  @Watch("wallet")
  public onWalletChanged() {
    this.getTransactions();

    this.getSentCount();
    this.getReceivedCount();
    this.getLocksCount();
  }

  public mounted() {
    this.getTransactions();

    this.getSentCount();
    this.getReceivedCount();
    this.getLocksCount();
  }

  private async getTransactions() {
    this.transactions = null;

    if (this.wallet.name !== undefined) {
      // @ts-ignore
      const data = await TransactionService[`${this.type}ByAddress`](this.wallet.name, 1);
      this.transactions = data.map((transaction: ITransaction) => ({ operations: [transaction[1].op], block_num : transaction[1].block, transaction_id : transaction[1].trx_id, expiration : transaction[1].timestamp })).reverse();
    }
  }

  private async getCountByType(type: string) {
    if (this.wallet && this.wallet.name) {
      try {
        const response = await TransactionService[`${type}ByAddressCount`](this.wallet.name);
        this[`${type}Count`] = response;
      } catch (error) {
        this[`${type}Count`] = 0;
      }
    }
  }

  private getReceivedCount() {
    this.getCountByType("received");
  }

  private getSentCount() {
    this.getCountByType("sent");
  }

  private getLocksCount() {
    this.getCountByType("locks");
  }

  private setType(type: string) {
    this.type = type;

    this.getTransactions();
  }

  private onSortChange(params: ISortParameters) {
    this.sortParams = params;
  }
}
